import React, { useEffect, useState } from "react";
import GraduateIntro from "../components/graduate/GraduateIntro";
import GraduateIntroBanner from "../components/graduate/GraduateIntroBanner";
import GraduateTab from "../components/graduate/GraduateTab";
import Banner from "../components/Banner";
import { dynamicFailed } from "../hooks/custom/useToast";
import {
  fetchAcademicsMppBackground,
  fetchAcademicsMppDetailsBanner,
} from "../api/GraduateProgramsApi";
import {
  IAcademicsMppBackgroundData,
  IAcademicsMppDetailsBannerData,
} from "../exports/interfaces";
import { useLoader } from "../context/LoaderContext";

const GraduatePage = () => {
  const { setLoading } = useLoader();
  const [academicsMppBackground, setAcademicsMppBackground] = useState<
    IAcademicsMppBackgroundData[]
  >([]);
  const [academicsMppDetailsBanner, setAcademicsMppDetailsBanner] = useState<
    IAcademicsMppDetailsBannerData[]
  >([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchAcademicsMppBackground(),
      fetchAcademicsMppDetailsBanner(),
    ])
      .then(([academicsMppBackgroundData, academicsMppDetailsBannerData]) => {
        setAcademicsMppBackground(academicsMppBackgroundData);
        setAcademicsMppDetailsBanner(academicsMppDetailsBannerData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);
  return (
    <>
      <Banner title="Academics" />
      <GraduateIntro academicsMppBackground={academicsMppBackground} />
      <GraduateIntroBanner
        academicsMppDetailsBanner={academicsMppDetailsBanner}
      />
      <GraduateTab />
    </>
  );
};

export default GraduatePage;
